export default "__VITE_ASSET___zhG4DRE__"